import Box from '@mui/material/Box'
import dynamic from 'next/dynamic'
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import useExtraDialog from '@components/_hooks/Cart/useExtraDialog';

const ProductCarousel = dynamic(() => import("../ProductComponent/Carousel/ProductCarousel"))
const PageTitle = dynamic(() => import("../Reusables/PageTitle"))
const ProductExtrasDialog = dynamic(() => import("../ProductComponent/ProductExtrasDialog"), { ssr: false })

const padding = {
    padding: {
        xs: 0,
        lg: 0
    },
    minHeight: {
        xs: '458px',
        md: '445px',
        lg: '490px'
    },
    height: '100%'
}

const HomeProductCarousel = ({ tabs, long_term, data, elevation = 2, tabKey = 'featured' }) => {

    const { getSetting, getPageSetting } = useGlobalSettings();
    const { open, handleToggle, extraProductData, setExtraProductData } = useExtraDialog();

    return (
        <>

            <PageTitle component="h3" className="text-center uppercase fw-semi-bold default-grey m-0">{getSetting('customer_favourites_text', 'Customer Favourites')}</PageTitle>

            {open && extraProductData?.product?.product_id && (
                <ProductExtrasDialog extrasData={extraProductData} open={open} toggle={handleToggle} />
            )}

            <Box sx={padding} >
                <ProductCarousel
                    products={tabs[tabKey].products}
                    long_term={long_term}
                    productData={data}
                    sectionID={4}
                    elevation={elevation}
                    extrasHook={{
                        open,
                        handleToggle,
                        extraProductData,
                        setExtraProductData
                    }}
                />
            </Box>
        </>
    )
}

export default HomeProductCarousel